import FormItem from "components/Form/FormItem";
import GallerySlider from "components/GallerySlider/GallerySlider";
import { getCommissionSetting, getCountries, getCountriesToAdd } from "functions/redux/country/action";
import { currency, showAlert } from "functions/redux/general/action";
import { ADD_MODE, dataDeleteService, EDIT_MODE, getGuidePrivateTrip, privateTripCheck, resetForm, submitOpenTrip, submitPrivateTrip, updateFormTrip } from "functions/redux/listing/action";
import { RootStore } from "functions/redux/store";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Input from "shared/Input/Input";
import NcModal from "shared/NcModal/NcModal";
import Select from "shared/Select/Select";
import ncNanoId from "utils/ncNanoId";
import PrivateStepAva from "./stepper/PrivateStepAva";
import PrivateStepOne from "./stepper/PrivateStepOne";
import PrivateStepThree from "./stepper/PrivateStepThree";
import PrivateStepTwo from "./stepper/PrivateStepTwo";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const PagePrivateAdd = () => {
    const location = useLocation();
    const search = location.search;
    const idEdit = new URLSearchParams(search).get("id");
    const dispatch = useDispatch();
    const { listing, countriesReducer, user, general } = useSelector((state: RootStore) => state);
    const [chooseCountry, setChooseCountry] = useState(true);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState<any>();
    const [loading, setLoading] = useState("");
    const [step, setStep] = useState(1);
    const { t } = useTranslation();
    const history = useHistory();
    const [isTerm, setIsTerm] = useState(false);
    const [isCancel, setisCancel] = useState(false);

    useEffect(() => {
        if (countriesReducer.commissionSetting == null) {
            dispatch(getCommissionSetting());
        }
        if (countriesReducer.countries == null) {
            if (idEdit) {
                dispatch(getCountries());
            } else {
                dispatch(getCountriesToAdd());
            }
        }
        if ((listing.addMode === ADD_MODE || listing.addMode === EDIT_MODE) && chooseCountry) {
            setChooseCountry(false);
        }
        if (listing.addMode !== null && selectedCountry?.id == null) {
            dispatch(resetForm());
        }
        dispatch(dataDeleteService(null));

    }, [])



    const findCountryData = async () => {
        setLoading('country');
        await dispatch(privateTripCheck(selectedCountry?.id));
        await dispatch(updateFormTrip("country", selectedCountry?.id));
        setLoading('');
    }

    const findCountryDataEdit = async (e: any) => {
        setLoading('country');
        await dispatch(privateTripCheck(e?.id));
        await dispatch(updateFormTrip("country", e?.id));
        setLoading('');
    }

    const overview = () => {
        return (<div className="border-b border-neutral-200 dark:border-neutral-700">
            <div
                className={`w-full h-full flex flex-col group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow `}
            >
                <div className="relative w-full">
                    {/* <GallerySlider className="max-h-80" galleryImgs={[
                        "https://images.pexels.com/photos/1268871/pexels-photo-1268871.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
                        "https://images.pexels.com/photos/2373201/pexels-photo-2373201.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                    ]} /> */}
                </div>
                <div className="mt-4 p-4 space-y-4">
                    <div className="space-y-4">
                        <div className="flex flex-row items-center space-x-4">
                            <Avatar sizeClass="w-20 h-20" imgUrl={user?.credential?.profile?.avatar} />
                            <div className=" flex flex-col space-y-1">
                                <h2 className={`font-semibold capitalize font-medium text-lg !mb-0`}>
                                    <span className="">{user?.credential?.guideDetail?.agencyName}</span>
                                </h2>
                                <div>
                                    <span className="text-neutral-500 dark:text-neutral-400 text-sm  mt-0">{selectedCountry?.name}</span>
                                    {
                                        listing?.addOpenTrip?.productLocation &&
                                        <Badge name={`${listing?.addOpenTrip?.productLocation.length} recommendations`} href="#" className="w-auto ml-2" color="green" />
                                    }

                                </div>

                            </div>
                        </div>
                        <div className="flex-col mt-6 space-y-4">
                            <span className=" text-neutral-500 dark:text-neutral-400 text-sm italic flex">{listing?.addOpenTrip?.highlight ?? "Add highlight"}</span>
                            <span className="!whitespace-pre-wrap text-neutral-600 dark:text-neutral-500 text-sm">{listing?.addOpenTrip?.description ?? "Add description"}</span>
                        </div>

                    </div>
                    <div className=" border-b border-neutral-100 dark:border-neutral-800"></div>
                    <div className="flex justify-between items-center">
                        <span className="text-base font-semibold">
                            {currency(listing.addOpenTrip?.totalPrice ? parseInt(listing.addOpenTrip?.totalPrice) : 0)}
                            <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                                / Day
                            </span>
                        </span>
                        <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
                            <span className="">{listing?.addOpenTrip?.maxGuest ?? 0} Guests included</span>
                        </div>

                    </div>
                </div>
            </div>
        </div>);
    }
    const renderStep = (param: any) => {
        switch (param) {
            case 2:
                return <PrivateStepTwo form={listing.addOpenTrip} country={selectedCountry} />;
            case 3:
                return <PrivateStepThree form={listing.addOpenTrip} country={selectedCountry} />;
            default:
                return <PrivateStepOne form={listing.addOpenTrip} country={selectedCountry} />;
        }
    }

    const chooseCountryContent = () => {
        return (<div >
            <FormItem
                label=""
                desc={t('choose_country_desc')}
            >
                <Select
                    value={selectedCountry ? JSON.stringify(selectedCountry) : ""}
                    onChange={(e) => {
                        if (e.target.value) {
                            setSelectedCountry(JSON.parse(e.target.value));
                        }
                    }}
                >
                    <option key={ncNanoId()} value="">{t('choose_country')}</option>
                    {countriesReducer.countries != null && (countriesReducer.countries).map((e: any) => {
                        if ((idEdit != null || idEdit !== undefined) && selectedCountry == null && e.id == idEdit) {
                            setSelectedCountry(e);

                            // findCountryData();
                            findCountryDataEdit(e);
                        }
                        return (<option key={ncNanoId()} value={JSON.stringify(e)}>{e.name}</option>);
                    }
                    )}
                </Select>
            </FormItem>
            <div className="flex justify-end space-x-5 mt-6">
                <ButtonPrimary className="w-full" onClick={findCountryData}>
                    {
                        loading === "country" ?
                            <Loader
                                type="Circles"
                                color="#ffffff"
                                height={25}
                                width={25}
                            /> : t('choose_country')
                    }
                </ButtonPrimary>
            </div>
        </div>);
    }
    const formAdd = () => {
        return (<div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-70 px-4 py-4 sm:p-4 xl:p-4">
            <div
                className={`max-w-3xl`}
            >
                <div className="space-y-11">
                    <div className="listingSection__wrap ">
                        {renderStep(step)}
                    </div>
                    <div className="flex justify-end space-x-5">
                        {step > 1 ? <ButtonSecondary onClick={goBack} >{t('go_back')}</ButtonSecondary> : <></>}
                        <ButtonPrimary
                            onClick={continueBtn}
                        >
                            {
                                loading === "submit" ?
                                    <Loader
                                        type="Circles"
                                        color="#ffffff"
                                        height={25}
                                        width={25}
                                    /> : (step < 3 ? t('continue') : t('submit'))
                            }

                        </ButtonPrimary>
                    </div>
                </div>
            </div>
        </div >
        );
    }

    const submitProduct = async () => {
        setLoading("submit");
        var result = await submitPrivateTrip(listing.addOpenTrip);
        if (result) {
            dispatch(resetForm());
            dispatch(getGuidePrivateTrip());
            history.replace('/profile');
            dispatch(showAlert("Your trip has been submitted, our team will review it before it can be access to our users", "Success", true));
        } else {
            setLoading("");
        }
    }

    const continueBtn = () => {

        if (loading !== "submit") {
            if (step === 2 && listing.addOpenTrip.productImages === undefined) {
                toast("Tambahkan minimal satu gambar");

                // submitProduct();
            } else
                if (step === 3) {
                    setShowConfirmation(true);
                    // submitProduct();
                } else {
                    setStep(step + 1);
                }
        }
    }

    const goBack = () => {
        setStep(step - 1);
    }
    return (<div
        className="relative flex flex-col lg:flex-row items-center py-14"
    >
        <ToastContainer position="bottom-right" />
        {/* <NcModal
            isOpenProp={general.alert.show}
            renderTrigger={() => { return (<div></div>); }}
            renderContent={() => { return general.alert.content; }}
            onCloseModal={() => {
                dispatch(resetForm());
                dispatch(showAlert("", "", false))
                history.replace('/profile');
                // window.location.reload();
            }
            }
            modalTitle={general.alert.title}
        /> */}
        <NcModal
            isOpenProp={(listing.addMode === EDIT_MODE && listing.detailGuideTrip == null) || listing.addMode === null}
            renderTrigger={() => { return (<div></div>); }}
            renderContent={() => { return chooseCountryContent(); }}
            onCloseModal={async () => {
                history.replace("/profile");
            }
            }
            modalTitle={t('choose_country')}
        />
        <NcModal
            isOpenProp={showConfirmation}
            renderTrigger={() => { return (<div></div>); }}
            renderContent={() => {
                return (
                    <div className="max-w-md">
                        <p className="text-center font-regular ">
                            Your price will be adjusted with commission fee, if you are not
                            aware of that tap the button on completion section to see
                            detail. You want to continue to submit?
                        </p>
                        <hr className="my-4" />
                        <div className="flex flex-col" style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                            <label className="flex" style={{ justifyContent: 'flex-start' }}>
                                <input
                                    style={{ position: 'relative', top: 5 }}
                                    className="mr-2"
                                    name="isGoing"
                                    type="checkbox"
                                    checked={isTerm}
                                    onChange={() => setIsTerm(!isTerm)} />
                                <div className="text-left">I have read and agree to the <a href="/term-and-condition" target={"_blank"} className="text-primary-6000">Terms and Conditions</a> of Guidesantai</div>
                            </label>
                            <label className="flex" style={{ justifyContent: 'flex-start' }}>
                                <input
                                    style={{ position: 'relative', top: 5 }}
                                    className="mr-2"
                                    name="isGoing"
                                    type="checkbox"
                                    checked={isCancel}
                                    onChange={() => setisCancel(!isCancel)} />
                                <div className="text-left">I have read and agree to the <a href="/cancelation-policy" target={"_blank"} className="text-primary-6000">Cancelation Policy</a> of Guidesantai</div>
                            </label>
                        </div>
                        <div className="flex justify-end space-x-5 mt-8">
                            <ButtonSecondary onClick={() => setShowConfirmation(false)} >{t('go_back')}</ButtonSecondary>
                            <ButtonPrimary disabled={isCancel && isTerm ? false : true} onClick={() => {
                                setShowConfirmation(false);
                                submitProduct();
                            }}
                            >{t('continue')}
                            </ButtonPrimary>
                        </div>
                    </div>
                )
            }}
            hideCloseBtn={true}
            // contentExtraClass="w-1/4"
            modalTitle={t('confirmation')}
        />

        <main className="container mb-24 lg:mb-32 flex flex-col lg:flex-row">
            <div className="flex-grow">
                {listing.addMode != null && selectedCountry?.id != null && (formAdd())}
            </div>
            <div className="max-w-2xl flex-shrink-0 mb-10 lg:mb-0 lg:pl-16 lg:w-2/5">
                {overview()}
            </div>
        </main>
    </div>);
}

export default PagePrivateAdd;
